import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { DataGrid } from '@mui/x-data-grid';
import Swal from 'sweetalert2';
import {Link, useParams} from 'react-router-dom';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {baseUrl, baseimgUrl, userLocation, ipAddress, userName, formatDateTime} from '../../Univ.js'

function OtRequest(props){

  const {ip_id} = useParams();
  const [ipData, setIpData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [roomData, setRoomData] = useState([]);
  const [roomNoData, setRoomNoData] = useState([]);
  const [surData, setSurData] = useState([]);
  const [selectedDateTime, setSelectedDateTime] = useState(new Date());
  const [selectedRoomType, setSelectedRoomType] = useState('');
  const [otData,setotData]=useState({
        "ip":'',
        "room_no":'',
        "ot_type":'',
        "surgeon":'',
        "nurse":'',
        "anesthetist":'',
        "comments":'',
        "surg_time":'',
        "status":'',
        "addedby":'',
        "ip_add":'',
    });

  useEffect(() => {
    fetchData();
  }, []);

  function fetchData() {
    axios.get(baseUrl + "edit-ip-admit/" + ip_id + "/")
      .then(response => {
        setIpData([response.data]);
      })
      .catch(error => {
        console.log(error);
      });
  }

  useEffect(() => {
    fetchRoomData();
    fetchsurData();
  }, []);

  function fetchRoomData() {
    axios.get(baseUrl + "room-type/")
      .then(response => {
        setRoomData(response.data);
      })
      .catch(error => {
        console.log(error);
      });
  }

  useEffect(() => {
   if (selectedRoomType) {
    fetchRoomNoData(selectedRoomType);
   }
  }, [selectedRoomType]);

  const handleRoomTypeChange = (event) => {
    const selectedRoomTypeId = event.target.value;
    setSelectedRoomType(selectedRoomTypeId);
  };

  function fetchRoomNoData(selectedRoomTypeId) {
    axios.get(baseUrl + "room-no/" + selectedRoomTypeId)
      .then(response => {
        setRoomNoData(response.data);
      })
      .catch(error => {
        console.log(error);
      });
  }
  function fetchsurData() {
    setIsLoading(true);
    axios.get(`${baseUrl}surgery-type-create/`)
      .then(response => {
        setSurData(response.data);
        setIsLoading(false);
      })
      .catch(error => {
        console.log(error);
        setIsLoading(false);
      });
  }

    const inputHandler = (event) => {
      const { name, value } = event.target;
      const updatedotData = { ...otData, [name]: value };
        setotData(updatedotData);
    };

  const formSubmit = (e) => {
      e.preventDefault();
         const room_no = document.getElementById("room_no").value;
         const ot_type = document.getElementById("ot_type").value;
         const surgeon = document.getElementById("surgeon").value;
         const anesthetist = document.getElementById("anesthetist").value;
         const nurse = document.getElementById("nurse").value;
         const comments = document.getElementById("comments").value;
         const surg_time = document.getElementById("surg_time").value;

          const _formData = new FormData();
          _formData.append('ip', ip_id);
          _formData.append('room_no', room_no);
          _formData.append('ot_type', ot_type);
          _formData.append('surgeon', surgeon);
          _formData.append('anesthetist', anesthetist);
          _formData.append('nurse', nurse);
          _formData.append('comments', comments);
          _formData.append('surg_time', surg_time);
          _formData.append('status', '1');
          _formData.append('addedby', userName);
          _formData.append('ip_add', ipAddress);
          _formData.append('location', userLocation);

          axios.post(`${baseUrl}surgery-create/`, _formData)
            .then(response => {
              if(response.status==200 || response.status==201){
                Swal.fire({
                  title: 'New Surgery has been added.',
                  icon: 'success',
                  timer: 5000,
                  showConfirmButton: false
                });
                setTimeout(() => {
                  window.location.href = '/ot-request/'+ ip_id +'/';
                }, 3000);
              }
            })
            .catch(error => {
              console.log(error);
              Swal.fire(
                'Error!',
                'Failed to add min entry. Please try again later.',
                'error'
              );
            });
  };
     const handleDateTimeChange = (datetime) => {
        setSelectedDateTime(datetime);
    };


    return (
    <section className="container mt-4">
     <h3 className="text-center" style={{ color: 'black', backgroundColor: '#e5eaef', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <i className="fa-solid fa-stethoscope" aria-hidden="true" style={{ color: 'red' }}></i>
      Primary Consultant -  Dr.{ipData.map(row => row.primary_consult.consultant)}
    </h3>
    <div className="table-responsive">
    <table className="erp-table-modern">
        <thead>
        <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
          <th>Patient</th>
          <th>IP ID</th>
          <th>Patient ID</th>
          <th>Patient Name</th>
          <th>Gender</th>
          <th>D.O.B/Age</th>
          <th>Mobile</th>
          <th>Regd. On</th>
        </tr>
      </thead>

      <tbody>
        {ipData.map((patientData, index) => (
          <tr >
          <td><img src={patientData.profile_pic} alt="Thumbnail" className="thumbnail" style={{width:120, height:60}}/></td>
            <td>{patientData.ip_id}</td>
            <td>{patientData.pat.pat_id}</td>
            <td>{patientData.pat.patient}</td>
            <td>{patientData.pat.gender}</td>
            <td>{patientData.pat.age}</td>
            <td>{patientData.pat.mobile}</td>
            <td>{formatDateTime(patientData.admit_date)}</td>
          </tr>
        ))}
      </tbody>
    </table>
    </div>
  <div >
  <h3 className="text-center" style={{ color: 'black', backgroundColor: '#e5eaef', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <i className="fa-solid fa-scissors" aria-hidden="true" style={{ color: 'red' }}></i>
      OT Request
    </h3>
      <form>
      <div className="row">
        <div className="col-md-2 ms-1">
            <label htmlFor="room" className="form-label">Room Type</label>
            <select
              className="form-control"
              value={selectedRoomType}
              name="room"
              id="room"
              onChange={handleRoomTypeChange}
            >
              <option>Select Room Type </option>
              {roomData.map((room, index) => (
                <option key={index} value={room.id}>
                  {room.room}
                </option>
              ))}
            </select>
          </div>
          <div className="col-md-2 ms-1">
            <label htmlFor="room_no" className="form-label">Room No</label>
            <select className="form-control" value={otData.room_no} name="room_no" id="room_no" onChange={inputHandler}>
              {roomNoData.map((roomno, index) => (
                <option key={index} value={roomno.id}>
                  {roomno.room_no}
                </option>
              ))}
            </select>
          </div>
        <div className="col-md-2 ms-1">
          <label htmlFor="Advance Type" className="form-label">Surgery Type</label>
          <select className="form-control"
            name="ot_type" id="ot_type" >
            <option>Select Surgery Type </option>
            {surData.map((sur,index) => {return <option key={index} value={sur.id}>{sur.type}
            </option>})}
          </select>
        </div>
        <div className="col-md-2 ms-1">
          <label htmlFor="Tempr" className="form-label">Surgeon : </label>
          <input
            type="text"
            className="ms-1 form-control"
            name="surgeon"
            id="surgeon"
          />
        </div>
        <div className="col-md-2 ms-1">
          <label htmlFor="Tempr" className="form-label">Anesthetist : </label>
          <input
            type="text"
            className="ms-1 form-control"
            name="anesthetist"
            id="anesthetist"
          />
        </div>
        <div className="col-md-2 ms-1">
          <label htmlFor="Tempr" className="form-label">Nurse : </label>
          <input
            type="text"
            className="ms-1 form-control"
            name="nurse"
            id="nurse"
          />
        </div>
        <div className="col-md-2 ms-1">
        <label htmlFor="Notes" className="form-label">Comments : </label>
          <textarea
          className="no-comma form-control"
          tabIndex="0"
          name="comments"
          id="comments"
          ></textarea>
        </div>
        <div className="col-md-2 ms-1">
          <label htmlFor="Notes Time" className="form-label">Surgery Time : </label>
          <DatePicker className="form-control" name="surg_time" id="surg_time" selected={selectedDateTime}
                            onChange={handleDateTimeChange}
                            dateFormat="yyyy-MM-dd h:mm"
                            showTimeSelect
                            timeIntervals={15}
                            timeCaption="Time"
                        />
        </div>
       </div>
      <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}
        className='ms-5' >
          <button type="button" onClick={formSubmit} className="btn btn-primary mt-4">Submit</button>
        </div>
      </form>

  </div>
    </section>
    )
}

export default OtRequest;